import {
  CapaQuotationChatMessage,
  CapaQuotationUserRfqDetail
} from '@generated/graphql';
import { SubscribeMessage } from '@modules/chatMessages';
import React from 'react';
import ChatDateDividerPresenter from '../ChatBubble/ChatDateDividerPresenter';
import ChatMessageBubblePresenter from '../ChatBubble/ChatMessageBubblePresenter';
import CommonBubble from '../ChatBubble/CommonBubble';

interface BubbleMemoComponentProps {
  message: SubscribeMessage;
  isCommonMessage: boolean;
  isOwner: boolean;
  renderDateDivider: boolean;
  rfqDetail?: CapaQuotationUserRfqDetail;
}

const BubbleMemoComponent = React.memo(
  ({
    isCommonMessage,
    isOwner,
    message,
    renderDateDivider,
    rfqDetail
  }: BubbleMemoComponentProps) => {
    return (
      <>
        {isCommonMessage ? (
          <CommonBubble message={message as CapaQuotationChatMessage} />
        ) : (
          <ChatMessageBubblePresenter
            isOwner={isOwner}
            message={message as CapaQuotationChatMessage}
            rfqDetail={rfqDetail as CapaQuotationUserRfqDetail}
          />
        )}

        {renderDateDivider && (
          <ChatDateDividerPresenter
            createdAt={message.createdAt ?? undefined}
            unread={false}
          />
        )}
      </>
    );
  }
);

export default BubbleMemoComponent;
